





































































import Vue from 'vue';
import { Prop, Component, Watch } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
	@Prop({ type: String, default: 'Error' }) title!: string;

	@Prop({ type: String, default: '' }) messageText!: string;

	@Prop({ type: String, required: true }) name!: string;

	@Prop({ type: Boolean, required: true }) showModal!: boolean;

	@Prop({ type: String, default: '500px' }) width!: string;

	@Prop({ type: Boolean, default: false }) full!: boolean;

	@Prop({ type: String, default: 'Ok' }) buttonText!: string;

	show = false;

	closeModal() {
		this.$root.$emit(`close${this.name}Modal`);
	}

	@Watch('showModal', { immediate: true, deep: true })
	protected onShowModalChanged(val: boolean) {
		this.show = val;
	}
}
